import React from "react";

const CommonFooter = () => {
  return (
    <div>
      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0">2014 - 2025 © MissNail. All Right Reserved</p>
        <p>
          Designed &amp; Developed by MissNail
        </p>
      </div>
    </div>
  );
};

export default CommonFooter;
